export default __webpack_public_path__ + "static/media/udemy.e4aba7a6.png";